import { render, staticRenderFns } from "./PenddingIncator.vue?vue&type=template&id=081b0a71&"
import script from "./PenddingIncator.vue?vue&type=script&lang=js&"
export * from "./PenddingIncator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports